define('helper-state-getComponent',['exports'], function (exports) {
    'use strict';

    Object.defineProperty(exports, "__esModule", {
        value: true
    });

    exports.default = function () {
        var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        var s = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';


        if (!state || !state.entity || !state.entity.components || typeof s !== 'string') {
            return {};
        }

        var components = state.entity.components;

        return components[s.toLowerCase()] ? components[s.toLowerCase()] : {};
    };
});
